<template>
  <v-toolbar color="primary">
    <v-toolbar-title class="white--text">
      {{ title }}
    </v-toolbar-title>
    <v-btn icon class="white--text" @click="closeDialog()">
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script setup lang="ts">
defineProps({
  title: {
    type: String,
    required: true
  },
  closeDialog: {
    type: Function,
    required: true
  }
})
</script>
